import {color_grey_dark, color_grey_light, color_grey_ultra_light} from "../../constants/colors";
import {OnestNormalBig, OnestNormalMed} from "../styled/TextComponents";

const NoContentPlaceholder = ({noDataText, height}) => {
    return (

        <div style={{
            width: "100%",
            height: height ? height : "100%",
            backgroundColor: color_grey_ultra_light,
            color: color_grey_dark,
            borderRadius: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div style={{
                height: "min-content",
                color: color_grey_dark,
                textAlign: "center",
            }}>
                <OnestNormalMed>{noDataText}</OnestNormalMed>
            </div>
        </div>
    )
}


export default NoContentPlaceholder